import { IS_BROWSER } from '$fresh/runtime.ts'
import { useEffect } from 'preact/hooks'

interface Props {
    queryId?: string
    page?: number
}

interface WindowWithDataLayer extends Window {
    dataLayer?: Record<string, unknown>[]
}

export default function AlgoliaHitsViewed({ queryId, page = 0 }: Props) {
    if (!IS_BROWSER || !queryId) return null

    useEffect(() => {
        const w = globalThis.window as WindowWithDataLayer
        w.dataLayer = w.dataLayer ?? []
        w.dataLayer.push({ event: 'Hits Viewed' })
    }, [queryId, page])

    return null
}
